import styles from "../Components/ProductList.module.css";
import Pen from "../ProductTypeComponents/Pen";
import Book from "../ProductTypeComponents/Book";
import Pencil from "../ProductTypeComponents/Pencil";
import Stationery from "../ProductTypeComponents/Stationery";
import Clothing from "../ProductTypeComponents/Clothing";
import PersonalCare from "../ProductTypeComponents/PersonalCare";
import { useEffect, useState } from "react";
import Api from "../Components/Api";
import { Link } from "react-router-dom";
import NoteBook from "../ProductTypeComponents/NoteBook";
import Grocery from "../ProductTypeComponents/Grocery";

const ShoptItemDetails = ()=>{ 
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const shopItemId = params.get('shopItemId'); 
  const shopId = params.get('shopid');  
  const [shoptItemDetails, setShopItemDetails] = useState({}); 
  const [shopName, setShopName] = useState()
  useEffect(()=> {
    Api.get(`/shop-item-details/${shopItemId}`)
        .then((response)=>{
            setShopItemDetails(shoptItemDetails => ({
                ...shoptItemDetails,
                ...response.data[0]
              }));            
        })
    Api.get(`/bread-crumb/${shopId}`).then((response) => {
        //console.log(response.data)
        setShopName(response.data[0].shop_name)
      })    

  },[])      
    
    return <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>            
        <div class="container-fluid">
           <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><Link to="/">Home</Link></li>
                      <li class="breadcrumb-item"><Link to={`/shop?shopid=${shopId}`}>{shopName}</Link></li>
                      <li class="breadcrumb-item active" aria-current="page">{shoptItemDetails.product_name}</li>
                    </ol>
                  </nav>
          {shoptItemDetails.product_type === 'Pen' ? <Pen shoptItemDetails={shoptItemDetails} /> : shoptItemDetails.product_type === 'Book' ? <Book shoptItemDetails={shoptItemDetails} /> : shoptItemDetails.product_type === 'Pencil' ? <Pencil shoptItemDetails={shoptItemDetails} /> : shoptItemDetails.product_type === 'Stationery' ? <Stationery shoptItemDetails={shoptItemDetails} /> : shoptItemDetails.product_type === 'Clothing' ? <Clothing shoptItemDetails={shoptItemDetails} /> : shoptItemDetails.product_type === 'Beauty and Hygein' ? <PersonalCare shoptItemDetails={shoptItemDetails} /> : shoptItemDetails.product_type === 'Note Book' ? <NoteBook shoptItemDetails={shoptItemDetails} /> : shoptItemDetails.product_type==='Grocery' ? <Grocery shoptItemDetails={shoptItemDetails} /> : ''}
        </div>
        </div>
    </>
}
export default ShoptItemDetails